import styles from './Reportar.module.scss';
import { CircleAlert, CircleCheckBig, CreditCard, FileText, TriangleAlert, Vote} from 'lucide-react';
import PageContainer from 'shared/components/pagecontainer/PageContainer';

export const Reportar = () => {



  return (
    <PageContainer title="Reportar um problema" icon={<TriangleAlert />}>
      <div className={styles.page}>
        <div className={styles.divOpcao}>
          <CircleAlert size={35} className={styles.iconPagamento}/>
          <div className={styles.divLink}>
            <h3 className={styles.titulo}>Erro no Pagamento</h3>
            <p className={styles.subTitulo}>Exibe erro com motivo legível e ações rápidas</p>
          </div>
        </div>
        <div className={styles.divOpcao}>
          <CreditCard size={35} className={styles.iconAlternativo}/>
          <div className={styles.divLink}>
            <h3 className={styles.titulo}>Método Alternativo</h3>
            <p className={styles.subTitulo}>Permite escolher outra forma de pagamento</p>
          </div>
        </div>
        <div className={styles.divOpcao}>
          <FileText size={35} className={styles.iconIncidente}/>
          <div className={styles.divLink}>
            <h3 className={styles.titulo}>Novo Incidente</h3>
            <p className={styles.subTitulo}>Formulário para reportar cobrança indevida</p>
          </div>
        </div>
        <div className={styles.divOpcao}>
          <FileText size={35} className={styles.iconDetalhes}/>
          <div className={styles.divLink}>
            <h3 className={styles.titulo}>Detalhe do Incidente</h3>
            <p className={styles.subTitulo}>Acompanhamento e timeline do incidente</p>
          </div>
        </div>
        <div className={styles.divOpcao}>
          <CircleCheckBig size={35} className={styles.iconResolucao}/>
          <div className={styles.divLink}>
            <h3 className={styles.titulo}>Resolução - Confirmado</h3>
            <p className={styles.subTitulo}>Pagamento confirmado com sucesso</p>
          </div>
        </div>

      </div>
    </PageContainer>
  )
}
